// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getDatabase } from "firebase/database";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDajXy4n7j6VJEAX3Wb_OKcpC6ruORuUhU",
  authDomain: "omkwebsite-d8f24.firebaseapp.com",
  databaseURL: "https://omkwebsite-d8f24-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "omkwebsite-d8f24",
  storageBucket: "omkwebsite-d8f24.firebasestorage.app",
  messagingSenderId: "86682829956",
  appId: "1:86682829956:web:cd39c3723b8ea24266eed1",
  measurementId: "G-2R9WN7HYWE"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Initialize Realtime Database (site verisi buradan okunuyor)
export const database = getDatabase(app);

export { analytics };
export default app;
